<!-- Contact Us -->
<h1 class="cwk-orange my-4">Contact Us</h1>
<hr />

<div class="p-3">

  <!-- Questions, comments or suggestions? -->
  <h3 class="mb-3">Questions, comments or suggestions?</h3>
  <div class="mb-3">
    Please check out our <a class="cwk-link cwk-blue-link" [routerLink]="['/faqs']" queryParamsHandling="preserve"><b>FAQs page</b></a> to review our full list of commonly asked questions. If you cannot find your answer there, or if you have any comments or suggestions, please reach out to us through the form below. Our goal is to respond to all enquiries within 24 hours. Please excuse us if we take longer over the weekend or during times with a high volume of questions.
  </div>

  <!-- Most common FAQs -->
  <h3 class="mb-3">Most common FAQs</h3>
  <div class="fix-row mb-5">
    <div class="col-12 col-lg-4 mb-3">
      <div class="cwk-button faq-btn" [routerLink]="['/faqs']" fragment="logistics-2" queryParamsHandling="preserve">How do I announce an absence?</div>
    </div>
    <div class="col-12 col-lg-4 mb-3">
      <div class="cwk-button faq-btn" [routerLink]="['/faqs']" fragment="logistics-3" queryParamsHandling="preserve">What is the meeting link for my class?</div>
    </div>
    <div class="col-12 col-lg-4 mb-3">
      <div class="cwk-button faq-btn" [routerLink]="['/faqs']" fragment="in-person-3" queryParamsHandling="preserve">How do I change my registration?</div>
    </div>
  </div>

  <script type="text/javascript" src="https://s3.amazonaws.com/assets.freshdesk.com/widget/freshwidget.js"></script>
  <style type="text/css" media="screen, projection">
    @import url(https://s3.amazonaws.com/assets.freshdesk.com/widget/freshwidget.css);
  </style>
  <!-- https://support.freshdesk.com/support/solutions/articles/154064-pre-populating-feedback-widget-form -->
  <iframe title="Feedback Form" class="freshwidget-embedded-form" id="freshwidget-embedded-form" [src]="freshDeskSrc" scrolling="no" height="480px" width="100%" frameborder="0"></iframe>

  <!-- For Urgent Issues -->
  <h2 class="mt-5 mb-3">For Urgent Issues</h2>
  <div class="mb-3">
    <p>Meeting link not working for you? Lost on your way to class or late for pick up? Stuck in the meeting waiting room? For urgent issues such as these, please reach out to us at the email below and include:</p>
    <ul>
      <li>your child's name</li>
      <li>your class name</li>
      <li>information on the issue to be addressed</li>
    </ul>
  </div>
  <h4><a class="cwk-link cwk-blue-link" href="mailto:urgent@codingwithkids.com">urgent&#64;codingwithkids.com</a></h4>

  <hr class="my-4"/>

  <!-- Main Office -->
  <h3 class="mb-3">Mailing address</h3>
  <div>Coding with Kids, LLC</div>
  <div>PO Box 5025</div>
  <div>Bellevue, WA 98009-5025</div>
</div>
